const SWISH_MOBILE_ERROR = 'Ange ett giltigt svenskt mobilnummer i format 07XXXXXXXX eller 467XXXXXXXX.';

export const normalizeSwishPayerAlias = (input: string): { value: string | null; error: string | null } => {
  const digits = input.replace(/\D/g, '');

  if (digits.length === 10 && digits.startsWith('07')) {
    return { value: `46${digits.slice(1)}`, error: null };
  }

  if (digits.length === 11 && digits.startsWith('46') && digits[2] === '7') {
    return { value: digits, error: null };
  }

  return { value: null, error: SWISH_MOBILE_ERROR };
};

export const isValidSwishPayerAlias = (input: string) => normalizeSwishPayerAlias(input).value !== null;
